module.exports = __webpack_public_path__ + "img/activity_2_img1.17d22508.png";